<div *ngIf="showInitFirstTimeApp else noShowFirstTimeApp">
  <mnf-slider-view (next)="firstTimeAppAction($event)"></mnf-slider-view>
</div>

<ng-template #noShowFirstTimeApp>

<mnf-loader *ngIf="loader" class="loader"></mnf-loader>
<router-outlet></router-outlet>

<div class="bg-cookie" *ngIf="showWarningCookies">
  <div class="cookies-container">
    <div class="d-flex flex-column flex-md-row justify-content-center">
      <p class="mb-0 text-center">
        Nuestro sitio utiliza cookies para brindarte una mejor experiencia. Al usar nuestro sitio estás aceptando
        nuestro
        <a href="https://monific.com/politica/aviso-de-privacidad" target="_blank" rel="noopener no-referrer">aviso de
          privacidad</a>.
      </p>

      <div class="text-center">
        <button class="mnf-btn" (click)="hideWarningCookies()">Aceptar</button>
      </div>
    </div>
  </div>
</div>

</ng-template >